import { t } from '@web/i18n';
import { Button, Dialog, DialogContent, DialogTitle } from '@web/ui/core/atoms';

/**
 * Confirmation dialog for assuming a card. Presentational — open state and the
 * claim mutation live in `useClaimCard`. Mirrors the `TransferActionDialog`
 * shape used elsewhere in the card header.
 */
export function ClaimConfirmDialog({
  open,
  pending,
  onConfirm,
  onCancel,
}: Readonly<{
  open: boolean;
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}>): React.JSX.Element | null {
  if (!open) return null;
  return (
    <Dialog
      open
      onOpenChange={(o) => {
        if (!o) onCancel();
      }}
    >
      <DialogContent>
        <DialogTitle className="text-base font-medium text-foreground">
          {t('card.claim.dialog.title')}
        </DialogTitle>
        <p className="text-meta text-muted-foreground">{t('card.claim.dialog.body')}</p>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" size="sm" onClick={onCancel}>
            {t('card.claim.dialog.cancel')}
          </Button>
          <Button variant="primary" size="sm" disabled={pending} onClick={onConfirm}>
            {t('card.claim.dialog.confirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
